export enum Directed {
    OWN = 'OWN',
    OTHER = 'OTHER',
}
export type TriggerOption = {
    operation: 'gt' | 'eq' | 'in';
    value: string | number | boolean;
};
export const config_V1: {
    [attrName: string]:
        | {
              shortText: string;
              fullText: string;
              triggerAnswerFromParent?: TriggerOption;
              affirmativeOption?: string;
              followupParent: string | null;
              directedFrom?: Directed;
              groupWith?: string;
              low?: string;
              high?: string;
          }
        | undefined;
} = {
    'phase2a.sidebar.highriskpullover': {
        shortText: 'High Risk Pullover',
        fullText:
            'Was this a high risk pullover, which is where the officer orders the driver out of the car before approaching?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.traffic': {
        shortText: 'Traffic',
        fullText: 'Was there heavy traffic?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.weather': {
        shortText: 'Weather',
        fullText:
            'Was there any unusual weather that may play a role in the communication during the stop (e.g., raining, windy)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.background': {
        shortText: 'Background',
        fullText:
            'Is there anything else happening in the background or surrounding area of the stop that somehow interfered with the communication of the traffic-stop?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.backgroundtype': {
        shortText: 'Background Type',
        fullText: 'What is happening in the background that can interfere with the traffic stop?',
        followupParent: 'phase2a.sidebar.background',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.popup.0.fear': {
        shortText: 'Fear',
        fullText: 'Does the {{label_type}} express fear?',
        low: 'Very Secure',
        high: 'Very Fearful',
        followupParent: null,
    },
    'phase2a.popup.0.feartype': {
        shortText: 'Fear Type',
        groupWith: 'phase2a.popup.0.fear',
        fullText: 'If fear is greater than 3, which type of fear?',
        followupParent: 'phase2a.popup.0.fear',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.popup.0.anger': {
        shortText: 'Anger',
        fullText: 'Does the {{label_type}} express anger?',
        low: 'Very Calm',
        high: 'Very Angry',
        followupParent: null,
    },
    'phase2a.popup.0.threatening': {
        shortText: 'Threatening',
        fullText: 'Does the {{label_type}} appear threatening (i.e. intending to cause harm)?',
        low: 'Not threatening at all',
        high: 'Very Threatening',
        followupParent: null,
    },
    'phase2a.popup.0.offensiveness': {
        shortText: 'Offensiveness',
        fullText: 'Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?',
        low: 'No Offensiveness',
        high: 'Very Offensive',
        followupParent: null,
    },
    'phase2a.popup.0.biasandhate': {
        shortText: 'Bias or Hate',
        fullText:
            "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        followupParent: 'phase2a.popup.0.offensiveness',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
        groupWith: 'phase2a.popup.0.offensiveness',
        low: 'No bias or hate',
        high: 'Clearly motivated by bias or hate',
    },
    'phase2a.popup.0.warmth': {
        shortText: 'Warmth',
        low: 'Very Cold',
        high: 'Very Warm',
        fullText: 'Does the {{label_type}} act warm or cold towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.0.respectful': {
        shortText: 'Respectful',
        low: 'Very Disrespectful',
        high: 'Very Respectful',
        fullText: 'Does the {{label_type}} act respectfully or disrespectfully towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.0.doesnotappear': {
        shortText: 'Does Not Appear',
        fullText: 'Does not appear in the previous section',
        followupParent: null,
    },
    'phase2a.popup.0.emotionopen': {
        shortText: 'Emotion Open',
        groupWith: 'phase2a.popup.0.emotionother',
        fullText:
            'Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}',
        followupParent: null,
    },
    'phase2a.popup.0.emotionother': {
        shortText: 'Emotion Other',
        fullText:
            'What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?',
        followupParent: null,
    },
    'phase2a.popup.1.doesnotappear': {
        shortText: 'Does Not Appear',
        fullText: 'Does not appear in the previous section',
        followupParent: null,
    },
    'phase2a.popup.1.fear': {
        shortText: 'Fear',
        fullText: 'Does the {{label_type}} express fear?',
        low: 'Very Secure',
        high: 'Very Fearful',
        followupParent: null,
    },
    'phase2a.popup.1.feartype': {
        shortText: 'Fear Type',
        groupWith: 'phase2a.popup.1.fear',
        fullText: 'If fear is greater than 3, which type of fear?',
        followupParent: 'phase2a.popup.1.fear',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.popup.1.anger': {
        shortText: 'Anger',
        fullText: 'Does the {{label_type}} express anger?',
        low: 'Very Calm',
        high: 'Very Angry',
        followupParent: null,
    },
    'phase2a.popup.1.threatening': {
        shortText: 'Threatening',
        low: 'Not threatening at all',
        high: 'Very Threatening',
        fullText: 'Does the {{label_type}} appear threatening (i.e. intending to cause harm or damage)?',
        followupParent: null,
    },
    'phase2a.popup.1.offensiveness': {
        shortText: 'Offensiveness',
        fullText: 'Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?',
        low: 'No Offensiveness',
        high: 'Very Offensive',
        followupParent: null,
    },
    'phase2a.popup.1.biasandhate': {
        shortText: 'Bias or Hate',
        fullText:
            "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        followupParent: 'phase2a.popup.1.offensiveness',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
        groupWith: 'phase2a.popup.1.offensiveness',
        low: 'No bias or hate',
        high: 'Clearly motivated by bias or hate',
    },
    'phase2a.popup.1.warmth': {
        shortText: 'Warmth',
        low: 'Very Cold',
        high: 'Very Warm',
        fullText: 'Does the {{label_type}} act warm towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.1.respectful': {
        shortText: 'Respectful',
        low: 'Very Disrespectful',
        high: 'Very Respectful',
        fullText: 'Does the {{label_type}} act respectfully towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.1.emotionopen': {
        shortText: 'Emotion Open',
        groupWith: 'phase2a.popup.1.emotionother',
        fullText:
            'Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}.',
        followupParent: null,
    },
    'phase2a.popup.1.emotionother': {
        shortText: 'Emotion Other',
        fullText:
            'What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?',
        followupParent: null,
    },
    'phase2a.popup.2.fear': {
        shortText: 'Fear',
        fullText: 'Does the {{label_type}} express fear?',
        low: 'Very Secure',
        high: 'Very Fearful',
        followupParent: null,
    },
    'phase2a.popup.2.feartype': {
        shortText: 'Fear Type',
        groupWith: 'phase2a.popup.2.fear',
        fullText: 'If fear is greater than 3, which type of fear?',
        followupParent: 'phase2a.popup.2.fear',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.popup.2.anger': {
        shortText: 'Anger',
        fullText: 'Does the {{label_type}} express anger?',
        low: 'Very Calm',
        high: 'Very Angry',
        followupParent: null,
    },
    'phase2a.popup.2.threatening': {
        shortText: 'Threatening',
        low: 'Not threatening at all',
        high: 'Very Threatening',
        fullText: 'Does the {{label_type}} appear threatening (i.e. intending to cause harm or damage)?',
        followupParent: null,
    },
    'phase2a.popup.2.offensiveness': {
        shortText: 'Offensiveness',
        fullText: 'Does the {{label_type}} act or behave offensively towards the {{opposing_label_type}}(s)?',
        low: 'No Offensiveness',
        high: 'Very Offensive',
        followupParent: null,
    },
    'phase2a.popup.2.biasandhate': {
        shortText: 'Bias or Hate',
        fullText:
            "If offensiveness is greater than 3, to what extent do you believe the {{label_type}}'s offensive behavior was motivated by bias or hate?",
        followupParent: 'phase2a.popup.2.offensiveness',
        triggerAnswerFromParent: {
            operation: 'gt',
            value: 3,
        },
        directedFrom: Directed.OWN,
        groupWith: 'phase2a.popup.2.offensiveness',
        low: 'No bias or hate',
        high: 'Clearly motivated by bias or hate',
    },
    'phase2a.popup.2.warmth': {
        shortText: 'Warmth',
        low: 'Very Cold',
        high: 'Very Warm',
        fullText: 'Does the {{label_type}} act warm towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.2.respectful': {
        shortText: 'Respectful',
        low: 'Very Disrespectful',
        high: 'Very Respectful',
        fullText: 'Does the {{label_type}} act respectfully towards the {{opposing_label_type}}?',
        followupParent: null,
    },
    'phase2a.popup.2.doesnotappear': {
        fullText: 'Does not appear in the previous section',
        shortText: 'Does Not Appear',
        followupParent: null,
    },
    'phase2a.popup.2.emotionopen': {
        shortText: 'Emotion Open',
        groupWith: 'phase2a.popup.2.emotionother',
        fullText:
            'Please describe the key words, facial expressions, body language, or actions that informed your emotional ratings of the {{label_type}}.',
        followupParent: null,
    },
    'phase2a.popup.2.emotionother': {
        shortText: 'Emotion Other',
        fullText:
            'What other emotions or attitudes would you say the {{label_type}} was expressing toward the {{opposing_label_type}}(s)?',
        followupParent: null,
    },
    'phase2a.sidebar.pullsafely': {
        shortText: 'Pull Safely',
        fullText: 'Does the officer state that the driver did not pull over as requested or was delayed in doing so?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.apologyciv': {
        fullText: 'Does the civilian apologize or express any regret for the violation?',
        shortText: 'Apology',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.apologyoff': {
        fullText:
            'Does the officer apologize for anything? (i.e. \u201cSorry for the inconvenience\u201d or \u201cmy fault\u201d)',
        shortText: 'Apology',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.thank': {
        shortText: 'Thank',
        fullText: 'Does the {{label_type}} thank the {{opposing_label_type}}?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.title': {
        shortText: 'Title',
        fullText:
            'Does the civilian refer to the officer using "sir", "Ma\'am", "Officer" or other appropriate formal title like "Sargeant"?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.hands': {
        shortText: 'Hands',
        fullText: 'Are the civilian hands visible to the officer when the officer first approaches the vehicle?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.handswheel': {
        shortText: 'Hands Wheel',
        fullText: 'Are the hands on the steering wheel?',
        followupParent: 'phase2a.sidebar.hands',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
        groupWith: 'phase2a.sidebar.hands',
    },
    'phase2a.sidebar.movements': {
        shortText: 'Movements',
        fullText:
            'Does the civilian make any sudden movements with their hands that the officer might perceive as dangerous?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.movementscommunication': {
        shortText: 'Movements Communication',
        fullText:
            'Does the civilian tell the officer in advance about the movements they are going to make or ask permission to move? (i.e. \u201a"I am going to reach into the glove box" OR \u201a"Is it OK if I?")',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.detailaskciv': {
        fullText: 'Does the civilian ask for clarification regarding the reason for the stop?',
        shortText: 'Detail Ask',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.detailaskoff': {
        fullText: 'Does the officer ask for clarification of details about the civilian\u2019s explanation?',
        shortText: 'Detail Ask',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.acknowledgefault': {
        shortText: 'Acknowledge Fault',
        fullText: 'Does the civilian acknowledge committing a violation or crime?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.challengeappropriateness': {
        shortText: 'Challenge Appropriateness',
        fullText:
            'Does the civilian challenge either the appropriateness/legitimacy of the stop (e.g., "Why did you pull me over, I did nothing wrong!") or the authority of the officer (e.g., "I don\'t have to listen to you")?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.perspectiveonleadup': {
        shortText: 'Justification',
        fullText:
            'Does the civilian provide an explanation or justification of their behavior that preceded or led to the stop?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.yell': {
        shortText: 'Yell',
        fullText: 'Does the {{label_type}} yell at the {{opposing_label_type}}?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.verbalattack': {
        shortText: 'Verbal Attack',
        fullText:
            'Does the {{label_type}} insult or verbally attack the {{opposing_label_type}} or another {{opposing_label_type}}?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.hatespeech': {
        shortText: 'Hate Speech',
        fullText: 'Does the {{label_type}} use hate speech (e.g. racist, sexist, or homophobic language)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.hatespeechopen': {
        shortText: 'Hate Speech Open',
        fullText:
            'Can you please explain the situation in which the hate speech was used and why you consider the language to be hate-based?',
        followupParent: 'phase2a.sidebar.hatespeech',
        directedFrom: Directed.OWN,
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.vulgar': {
        shortText: 'Vulgar',
        fullText: 'Does the {{label_type}} use vulgar language (i.e. curse words)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.cellphone': {
        shortText: 'Cell Phone',
        fullText: 'Does the civilian use their cell phone?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.cellphoneuse': {
        shortText: 'Cell Phone use',
        fullText: 'How is the civilian using their cell phone? Choose all that apply',
        followupParent: 'phase2a.sidebar.cellphone',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.threatenviolence': {
        shortText: 'Threaten Violence',
        fullText: 'Does the civilian threaten the officer with violence?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.violencefollowup': {
        shortText: 'Violence Type',
        fullText: 'Is this a verbal threat or physical intimidation?',
        followupParent: 'phase2a.sidebar.threatenviolence',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.leavevehicle': {
        fullText: 'Does the civilian leave the vehicle?',
        shortText: 'Leave Vehicle',
        followupParent: null,
    },
    'phase2a.sidebar.leavevehicleagainst': {
        shortText: 'Leave Vehicle Against',
        fullText: "Does the civilian try to leave the vehicle against the officer's instructions?",
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.force': {
        shortText: 'Force',
        fullText: 'Does the civilian use any force against the officer?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.forcetype': {
        shortText: 'Force Type',
        fullText: 'What type of force?',
        followupParent: 'phase2a.sidebar.force',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.weaponinvehicle': {
        shortText: 'Weapon in Vehicle',
        fullText:
            'Does the civilian appear to have a weapon in their vehicle or otherwise in their immediate possession?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.weapontype': {
        shortText: 'Weapon Type',
        fullText: 'What kind of weapon?',
        followupParent: 'phase2a.sidebar.weaponinvehicle',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.citation': {
        shortText: 'Citation',
        fullText: 'Is the civilian issued a citation or written warning?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.stateexactwarning/citation': {
        shortText: 'State Exact Warning/Citation',
        fullText: 'Does any officer state the exact warning or citation they give to the civilian?',
        followupParent: 'phase2a.sidebar.citation',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.citation_open': {
        shortText: 'Citation Open',
        fullText: 'Please briefly describe what citation or warning they were given:',
        followupParent: 'phase2a.sidebar.stateexactwarning/citation',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.impound': {
        shortText: 'Impound',
        fullText: "Is the civilian's car impounded?",
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.contrabandfound': {
        shortText: 'Contraband Found',
        fullText: 'Was any contraband found?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.contrabandlocation': {
        shortText: 'Contraband Location',
        fullText: 'Where was the contraband found?',
        followupParent: 'phase2a.sidebar.contrabandfound',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.contrabandtype': {
        shortText: 'Contraband Type',
        fullText: 'What type of contraband?',
        followupParent: 'phase2a.sidebar.contrabandfound',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.contrabandseized': {
        shortText: 'Contraband Seized',
        fullText: 'Was the contraband seized?',
        followupParent: 'phase2a.sidebar.contrabandfound',
        directedFrom: Directed.OWN,
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
    },
    'phase2a.sidebar.legalcounsel': {
        shortText: 'Legal Counsel',
        fullText: 'Does the civilian ever ask for legal counsel?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.dephomesec': {
        shortText: 'Homeland Security',
        fullText:
            'Do the police refer the civilians to the US dept of Homeland Security (e.g., Immigration and Customs Enforcement, Customs and Border Protection)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.detain': {
        shortText: 'Detain',
        fullText: 'Is the civilian being detained in a way that goes beyond the routine detention of a traffic stop?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.detainask': {
        shortText: 'Detain Ask',
        fullText: 'Does the civilian ask if they are being detained?',
        followupParent: null,
    },
    'phase2a.sidebar.detaintype': {
        shortText: 'Detain Type',
        fullText: 'How are they detained?',
        followupParent: 'phase2a.sidebar.detain',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.resist': {
        shortText: 'Resist',
        fullText: "Does the civilian resist any of the officer's physical or verbal requests for compliance?",
        followupParent: null,
    },
    'phase2a.sidebar.resisttype': {
        shortText: 'Resist Type',
        fullText: 'Which type of enforcement are they resisting?',
        followupParent: 'phase2a.sidebar.resist',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.allegemisconduct': {
        shortText: 'Allege Misconduct',
        fullText: 'Does the civilian allege that any of the officers on the scene have committed misconduct?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.allegetype': {
        shortText: 'Allege Type',
        fullText: 'What type of misconduct does the civilian allege? Choose all that apply',
        followupParent: 'phase2a.sidebar.allegemisconduct',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.allegeresponse': {
        shortText: 'Allege Response',
        fullText:
            'Does an officer respond to the misconduct allegation with any of the following? Choose all that apply:',
        followupParent: 'phase2a.sidebar.allegemisconduct',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.complaint': {
        shortText: 'Complaint',
        fullText: 'Does the civilian state that they wish to file a complaint or talk to a supervisor?',
        followupParent: null,
    },
    'phase2a.sidebar.providedl': {
        shortText: 'Provide DL',
        fullText: "Does the civilian provide their driver's license or ID?",
        followupParent: null,
    },
    'phase2a.sidebar.provideregistration': {
        shortText: 'Provide Registration',
        fullText: 'Does the civilian provide registration?',
        followupParent: 'phase2a.sidebar.askregistration',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.psychold': {
        fullText: 'Do the police put the civilian on a psychiatric hold?',
        shortText: 'Psych Hold',
        followupParent: null,
    },
    'phase2a.sidebar.clarity': {
        fullText:
            'Is there a time when the {{label_type}} cannot understand or is having difficulty understanding the {{opposing_label_type}}?',
        shortText: 'Clarity',
        affirmativeOption: 'Yes',
        followupParent: null,
    },
    'phase2a.sidebar.interrupt': {
        fullText:
            'At any point in the stop, does the {{label_type}} interrupt or attempt to interrupt the {{opposing_label_type}} when the {{opposing_label_type}} is speaking?',
        shortText: 'Interrupt',
        affirmativeOption: 'Yes',
        followupParent: null,
    },
    'phase2a.popup.0.formality': {
        shortText: 'Formality',
        fullText: "How formal is the officer's conduct when interacting with the civilians?",
        low: 'Very Informal',
        high: 'Very Formal',
        followupParent: null,
    },
    'phase2a.popup.0.empathy': {
        shortText: 'Empathy',
        fullText:
            "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        low: 'Very Unempathetic',
        high: 'Very Empathetic',
        followupParent: null,
    },
    'phase2a.popup.1.formality': {
        shortText: 'Formality',
        fullText: "How formal is the officer's conduct when interacting with the civilians?",
        low: 'Very Informal',
        high: 'Very Formal',
        followupParent: null,
    },
    'phase2a.popup.1.empathy': {
        shortText: 'Empathy',
        fullText:
            "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        low: 'Very Unempathetic',
        high: 'Very Empathetic',
        followupParent: null,
    },
    'phase2a.popup.2.empathy': {
        shortText: 'Empathy',
        fullText:
            "Does the officer express empathy for the civilian's actions (i.e. does the officer indicate that they understand and relate to what the civilian is feeling)?",
        low: 'Very Unempathetic',
        high: 'Very Empathetic',
        followupParent: null,
    },
    'phase2a.sidebar.greeting': {
        shortText: 'Greeting',
        fullText: 'Does the officer greet the civilian(s)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.introducename': {
        shortText: 'Introduce Name',
        fullText: 'Does the officer introduce themselves by name?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.introducedept': {
        shortText: 'Introduce Dept',
        fullText: 'Does the officer state the department for which they work?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.pullrequested': {
        shortText: 'Pull Requested',
        fullText: 'Does the officer state that the driver did not pull over as requested or was delayed in doing so?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.compliment': {
        shortText: 'Compliment',
        fullText:
            'Does the officer compliment the driver for anything? (e.g. \u201a"You\'re very organized" or \u201a"I like your hat.")',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.movementdirections': {
        shortText: 'Movement Directions',
        fullText:
            'Does the officer give the civilian any directions about how to move or not move ? (e.g., \u201a"keep your hands on the wheel" or \u201a"Reach slowly into the dash..")',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.movementcomply': {
        shortText: 'Movement Comply',
        fullText: 'Does the civilian comply with this direction?',
        followupParent: 'phase2a.sidebar.movementdirections',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.approachspeed': {
        shortText: 'Approach Speed',
        fullText: 'How fast did the officer walk when they approached the car?',
        followupParent: null,
    },
    'phase2a.sidebar.cartouch': {
        shortText: 'Car Touch',
        fullText: 'Does the officer touch the car as they approach?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.prior': {
        shortText: 'Prior',
        fullText:
            'Prior to initiating communication with the driver, does the officer state for the record why the vehicle was pulled over?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.priorlegalreason': {
        shortText: 'Prior Legal Reason',
        fullText: 'What is the reason for the pullover given?',
        followupParent: 'phase2a.sidebar.prior',
        directedFrom: Directed.OWN,
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
    },
    'phase2a.sidebar.priorsuspicion': {
        shortText: 'Prior Suspicion',
        fullText: 'Does the officer provide any reason why they believe the civilian may be involved in any crime?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.priorsuspicionreason': {
        shortText: 'Prior Suspicion Reason',
        fullText: 'What is the prior suspicion reason?',
        followupParent: 'phase2a.sidebar.priorsuspicion',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.reasonask': {
        shortText: 'Reason Ask',
        fullText: 'Does the officer ask the driver if they know why they have been stopped?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.reasongiven': {
        shortText: 'Reason Given',
        fullText: 'Does the officer provide the civilian with an explanation of why they were stopped?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.reasontype': {
        shortText: 'Reason Type',
        fullText: 'What is the reason for the stop that the officer gives to the civilian?',
        followupParent: 'phase2a.sidebar.reasongiven',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        affirmativeOption: 'Yes',
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.ifspeedinga': {
        shortText: 'If Speeding A',
        fullText: 'a. What was the speed limit? _____ (enter number)',
        followupParent: 'phase2a.sidebar.reasontype',
        triggerAnswerFromParent: {
            operation: 'in',
            value: 'Speeding',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.ifspeedingb': {
        shortText: 'If Speeding B',
        fullText: 'b. What was the reported speed? _____ (enter number)',
        followupParent: 'phase2a.sidebar.reasontype',
        triggerAnswerFromParent: {
            operation: 'in',
            value: 'Speeding',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.ifspeedingc': {
        shortText: 'If Speeding C',
        fullText: 'c. Was this a school zone, work zone, or other safety zone?',
        followupParent: 'phase2a.sidebar.reasontype',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'in',
            value: 'Speeding',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.anxiousapproach': {
        shortText: 'Anxious Approach',
        fullText: 'Does the officer approach the vehicle anxiously and/or with trepidation?',
        followupParent: null,
    },
    'phase2a.sidebar.perspectiveask': {
        shortText: 'Justification',
        fullText:
            'Does the officer provide an opportunity for the civilian to explain their situation (e.g., why they were doing what they were doing before they got pulled over)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.weaponask': {
        shortText: 'Weapon Ask',
        fullText: 'Does the officer ask whether the civilian and/or passenger(s) has a weapon?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.paroleask': {
        shortText: 'Parole Ask',
        fullText: 'Does the officer ask whether the civilian and/or passenger(s) are on parole or probation?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.duiask': {
        shortText: 'DUI Ask',
        fullText:
            'Does the officer ask whether the civilian has been drinking or using drugs or is in possession of drugs or alcohol?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.sobrietytest': {
        shortText: 'Sobriety Test',
        fullText: 'Does the officer give the civilian a field sobriety test?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.investigationask': {
        shortText: 'Investigation Ask',
        fullText:
            'Does the officer ask any other questions that seem to be aimed at investigating whether the civilian may be guilty of a crime/infraction other than a traffic or vehicle safety violation?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.investigationopen': {
        shortText: 'Investigation Open',
        fullText: 'What was that investigative question or questions?',
        followupParent: 'phase2a.sidebar.investigationask',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.stepoutask': {
        shortText: 'Step Out Ask',
        fullText: 'Does the officer tell the civilian to step out of the vehicle?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.stepoutreason': {
        shortText: 'Step Out Reason',
        fullText: 'Does the officer give a reason why they told the civilian to step out of the vehicle?',
        followupParent: 'phase2a.sidebar.stepoutask',
        affirmativeOption: 'Yes',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.searchask': {
        shortText: 'Search Ask',
        fullText: 'Does the officer ask permission to search the vehicle?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.searchpermission': {
        shortText: 'Search Permission',
        fullText: 'Was permission given to conduct a search?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
     'phase2a.sidebar.searchpermfree': {
        shortText: 'Search Permission Free',
        fullText: 'When the officer asked for permission to search, did they use any of the following approaches? Select all that apply:',
        followupParent: 'phase2a.sidebar.searchask',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.searchpermexplicit': {
        shortText: 'Search Permission Explicit',
        fullText: 'How did the civilian give consent for the search? Choose all that apply',
        followupParent: 'phase2a.sidebar.searchpermission',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.search': {
        shortText: 'Search',
        fullText: 'Does the officer conduct a search?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.options': {
        shortText: 'Options',
        fullText:
            'Does the officer give an explanation of the civilian\'s options about how to proceed during the stop (e.g., they say \u201a"Here are your available options, you can either pay the ticket or come to court")?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.cameramuffle': {
        shortText: 'Camera Muffle',
        fullText: 'Does the officer ever deliberately muffle or cover the camera?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.cameratap': {
        shortText: 'Camera Tap',
        fullText:
            'Does the officer ever tap on the camera to show other officers that it is on? (you will hear a tap in the audio and a shake of the screen while aimed at another officer)',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.backup': {
        shortText: 'Back Up',
        fullText: 'Does the officer call for a supervisor, back up, or other units?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.deflection': {
        shortText: 'Deflection',
        fullText: 'Does the officer use deflection and redirection techniques?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.investigationhelp': {
        shortText: 'Investigation Help',
        fullText:
            'Does the officer ask the civilian for assistance or information related to investigating crimes or enhancing safety in their community, such as asking whether they have seen a vehicle or individual of a particular description?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.publicsafetyobject': {
        shortText: 'Public Safety Object',
        fullText:
            'Does the officer otherwise attempt to engage the civilian as a partner in a public safety objective, like asking them to report certain things if the civilian observes them? (Note: Saying \u201a"Drive Safely" in closing is not enough.)',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.weapondrawn': {
        shortText: 'Weapon Drawn',
        fullText: 'Does the officer draw a weapon?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.summary': {
        shortText: 'Summary',
        fullText:
            'Does the officer provide a concluding description of the process and next steps (e.g., officer explains citation, next steps for court or payment, or clarifies any required actions)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.stopcomprehensioncheck': {
        shortText: 'Stop Comprehension Check',
        fullText:
            'Does the officer ask whether the civilian understood why they had been stopped? (Note: This DOES NOT include asking \u201a"do you know why I pulled you over?")',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.enforcementcomprehensioncheck': {
        shortText: 'Enforcement Comprehension Check',
        fullText:
            'Does the officer ask whether the civilian understood the enforcement action that was taken (e.g., the citation, warning, seizure, arrest, etc)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.endpositive': {
        shortText: 'End Positive',
        fullText:
            'Does the officer end the interaction with a statement with a positive sentiment (e.g., \u201a"drive safely"; \u201a"have a good day/night")?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.officerforce': {
        shortText: 'Officer Force',
        fullText: 'Does the officer use any force against the civilian(s)?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.officerforcetype': {
        shortText: 'Officer Force Type',
        fullText: 'What type of force?',
        followupParent: 'phase2a.sidebar.officerforce',
        directedFrom: Directed.OWN,
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
    },
    'phase2a.sidebar.handcuff': {
        shortText: 'Handcuff',
        fullText: 'Does the police officer place the civilian in handcuffs?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.arrest': {
        shortText: 'Arrest',
        fullText: 'Does the police officer arrest the civilian?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.suspicionindicated': {
        shortText: 'Suspicion Indicated',
        fullText:
            'Did the officer say anything during the stop, after deciding to pull the car over, that made them suspect the driver of other crimes besides the reason for the initial stop?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.suspicionopen': {
        shortText: 'Suspicion Open',
        fullText: 'What was the reason given for the suspicion?',
        followupParent: 'phase2a.sidebar.suspicionindicated',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.askregistration': {
        shortText: 'Ask Registration',
        fullText: 'Does the officer ask the civilian to provide registration?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.driverslicense': {
        fullText: "Does the officer ask the civilian to provide a driver's license or ID?",
        shortText: 'Ask Drivers License',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.officerthreatenviolence': {
        shortText: 'Officer Threaten Violence',
        fullText: 'Does the officer threaten the civilian with violence?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.officerviolencefollowup': {
        shortText: 'Officer Violence Type',
        fullText: 'Is this a verbal threat or physical intimidation?',
        followupParent: 'phase2a.sidebar.officerthreatenviolence',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },
    'phase2a.sidebar.exitvehicle': {
        shortText: 'Exit Vehicle',
        fullText: 'Does the officer request a civilian to leave the vehicle?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.freetoleave': {
        shortText: 'Free to Leave',
        fullText: 'Does the officer tell the civilians they are free to leave at the end of the stop?',
        followupParent: null,
    },
    'phase2a.sidebar.concernforsafety': {
        shortText: 'Concern for Safety',
        fullText:
            'Does the officer express concern for the civilian\'s safety (e.g. \u201a"that was dangerous, please drive safe" \u201a"I\'m looking out for your safety")?',
        followupParent: null,
        low: 'Not concerned at all',
        high: 'Very concerned',
    },
    'phase2a.sidebar.outofplace': {
        shortText: 'Out of Place',
        fullText:
            'Does the officer say or do anything that indicates the officer believes the civilian should not be in the neighborhood/location where they were pulled over?',
        followupParent: null,
    },
    'phase2a.sidebar.additionalunits': {
        shortText: 'Additional Units',
        fullText: 'Were there any additional units present in the stop?',
        followupParent: null,
    },
    'phase2a.sidebar.additionalarrive': {
        shortText: 'Additional Units Arrive',
        fullText: 'Do any additional units arrive on the scene after this unit?',
        followupParent: null,
        affirmativeOption: 'Yes',
    },
    'phase2a.sidebar.additionaltype': {
        shortText: 'Additional Units Type',
        fullText: 'What type of additional units arrive?',
        followupParent: 'phase2a.sidebar.additionalarrive',
        triggerAnswerFromParent: {
            operation: 'eq',
            value: 'Yes',
        },
        directedFrom: Directed.OWN,
    },

    // phase2b
    'phase2b.popup.recurring.doesnotappear': {
        shortText: 'Does Not Appear',
        fullText: 'Does not appear in the previous section',
        followupParent: null,
    },
    'phase2b.popup.recurring.respect': {
        shortText: 'Respect',
        fullText: 'Does the {{label_type}} act respectfully towards the {{opposing_label_type}}',
        followupParent: null,
        low: 'Very disrespectful',
        high: 'Very respectful',
        directedFrom: Directed.OWN,
    },

    // 'phase2b.popup.0.doesnotappear': {
    //     shortText: 'Does Not Appear',
    //     fullText: 'Does not appear in the previous section',
    //     followupParent: null,
    // },
    'phase2b.popup.0.overallrespect': {
        shortText: 'Overall Respect',
        fullText: 'Overall, how would you evaluate the {{label_type}}\'s respectfulness during this stop',
        followupParent: null,
        low: 'Very disrespectful',
        high: 'Very respectful',
        directedFrom: Directed.OWN,
    },

    'phase2b.popup.0.overallrespectopen': {
        shortText: 'Overall Respect Open',
        fullText: 'Can you please describe the specific situations or reasoning that led to your overall respect rating of the {{label_type}}',
        followupParent: null,
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.overallsummary': {
        shortText: '[DEPRECATED] Overall Summary',
        fullText: '[DEPRECATED DO NOT ANSWER] Can you please give a summary of the events in this stop including the reason for the stop, the actions of the police/civilians, and the conclusions for the stop? (3-6 sentences)',
        followupParent: null,
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.objectivesummary': {
        shortText: 'Objective Summary',
        fullText: 'How would you summarize the events of this stop in a court of law? Please write 3-6 complete sentences.',
        followupParent: null,
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.subjectivesummary': {
        shortText: 'Subjective Summary',
        fullText: 'How would you describe this stop to a friend? Please write 3-6 complete sentences.',
        followupParent: null,
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.legitimacy': {
        shortText: 'Legitimacy',
        fullText: 'Taken in entirety, does this stop represent legitimate policing?',
        followupParent: null,
        low: 'Very illegitimate',
        high: 'Very legitimate',
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.legitimacyopen': {
        shortText: 'Legitimacy Open',
        fullText: 'Please explain your reasoning in 3-6 sentences.',
        followupParent: null,
        directedFrom: Directed.OWN,
    },
    'phase2b.popup.0.danger': {
        shortText: 'Danger/Threat',
        fullText: 'How in danger or threatened do you think the {{label_type}} felt during this traffic stop?',
        followupParent: null,
        directedFrom: Directed.OWN,
        low: "Completely safe/Not at all threatened",
        high: "Extremely threatened/Felt in serious danger",
    },
    'phase2b.popup.0.metapdanger':{
        shortText: 'Meta-perception Danger/Threat',
        fullText: 'How in danger or threatened do you think the {{label_type}} thought the {{opposing_label_type}} felt during this stop?',
        followupParent: null,
        directedFrom: Directed.OWN,
        low: "Completely safe/Not at all threatened",
        high: "Extremely threatened/Felt in serious danger",
    },

};

const fillTextTemplate = (template: string, data: { [key: string]: string }) => {
    return Object.keys(data).reduce((prev, key) => prev.replaceAll(`{{${key}}}`, data[key]), template);
};

export const toDisplay_V1 = (
    attrSpec: any,
    jobAttributeSpec: any,
    attrVals: any,
    jobAttributes: any,
    attr: any,
    people: any[],
): boolean => {
    const attrConf = config_V1[attr.name];
    if (!attrConf) {
        return false;
    }

    if (attrConf.followupParent === null) {
        return true;
    }

    const parentAttrName = attrConf.followupParent;

    const parentAttrConf = config_V1[parentAttrName];
    if (!parentAttrConf) {
        return false;
    }

    if (attrConf.directedFrom === Directed.OWN) {
        const parentAttrId = attrSpec.filter((attr: any) => attr.name === parentAttrName)[0]?.id;
        // return attrVals[parentAttrId] === attrConf.triggerAnswerFromParent;
        if (!attrConf.triggerAnswerFromParent) {
            return false;
        }
        return isTriggerOptionSet(attrConf.triggerAnswerFromParent, attrVals[parentAttrId]);
    }

    if (
        people.some((person) => {
            const parentAttrId = person.label.attributes.filter((attr: any) => attr.name === parentAttrName)[0]?.id;
            if (!attrConf.triggerAnswerFromParent) {
                return false;
            }
            return isTriggerOptionSet(attrConf.triggerAnswerFromParent, person.attributes[parentAttrId]);
        })
    ) {
        return true;
    }

    if (
        jobAttributeSpec.some(
            (attr: any) =>
                attr.name === parentAttrName &&
                attrConf.triggerAnswerFromParent &&
                isTriggerOptionSet(attrConf.triggerAnswerFromParent, jobAttributes[attr.id]),
        )
    ) {
        return true;
    }

    return false;
};

export const isTriggerOptionSet = (triggerOptionconfig_V1: TriggerOption, value: string | boolean | number) => {
    let operator = triggerOptionconfig_V1.operation;
    let triggerValue = triggerOptionconfig_V1.value;
    switch (operator) {
        case 'eq':
            return value === triggerValue;
        case 'gt':
            return value > triggerValue;
        case 'in':
            return (value + '').split(',').includes(triggerValue +'')
    }
};

export const getFilledFullText_V1 = (attrName: string, labelName: string) => {
    const label_type = labelName.startsWith('person:Police') ? 'officer' : 'civilian';
    const opposing_label_type = labelName.startsWith('person:Police') ? 'civilian' : 'officer';
    return fillTextTemplate(config_V1[attrName]?.fullText || '', {
        label_type,
        opposing_label_type,
    });
};
